<template>
  <div id="body" class="is-2column"
    :class="[
      {'is-hidden-header': targetScrollFlg},
      {'is-preview-print': isPrintPreview},
      {'is-visible-login': group1.isFrontendLogin}
    ]">
  <BackgroundImage />
  <DocumentLink />

    <div v-if="group1.isFrontendLogin" class="login-bar">
      <span>フロントエンドログイン中</span>
      <span class="ml12">事例ID: {{ group1.qaCode }}</span>
      <span class="ml12">追録号数: {{ group1.manualRecomentationDisp }} </span>
    </div>

    <PCPrint />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->
    
    <!-- ノートの選択 -->
    <transition name="popup">
      <PCNoteSelect
        v-if="state.visibleNoteSelect"
        :type="'qa'"
        :pageId="group1.qaId"
        :title="group1.qaTitle"
        @closeSelectNote="state.visibleNoteSelect = false"
      />
    </transition>

    <!-- 書籍情報 -->
    <transition name="popup">
      <PCQAAboutBook
        v-show="state.visibleAboutBook"
        :parentGroup1="group1"
        @closeAboutBook="state.visibleAboutBook = false"
      />
    </transition>

    <!-- 書式ダウンロード -->
    <transition name="popup">
      <PCQADocumentDownloads
        v-show="state.visibleDocumentDownloads"
        :startLoading="state.visibleDocumentDownloads"
        @closeDocumentDownloads="state.visibleDocumentDownloads = false"
      />
    </transition>

    <!--内容現在＆関連情報(WLJ連携) -->
    <transition name="popup">
      <PCQARelatedData
        v-show="group1.visibleRelatedData"
        @closeRelatedData="group1.visibleRelatedData = false"
      />
    </transition>

    <!-- 新旧対照表(WLJ連携) -->
    <!-- <transition name="popup">
      <PCQAOldAndNewMappings
        v-show="group1.visibleOldAndNewMappings"
        @closeOldAndNewMappings="group1.visibleOldAndNewMappings = false"
      />
    </transition> -->

    <!-- 過去事例 -->
    <transition name="popup">
      <PCQASelectRevision
        v-show="state.visibleSelectRevision"
        :startLoading="state.visibleSelectRevision"
        @changeRevision="group1.changeRevision"
        @closeSelectRevision="state.visibleSelectRevision = false"
      />
    </transition>
    

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />

        <form @submit.prevent class="header-search">
          <div class="header-search-tab">
            <div 
             @click="
              if (state.visibleNavi) {group1.isFullSizeNavigation = false};
              state.visibleNavi = !state.visibleNavi
              "
              class="header-search-tab-item ga-qa-detail-mokuji"
              :class="{'is-active':state.visibleNavi}"
             >
              <span class="text ga-qa-detail-mokuji" role="tab" area-selected>目次</span>
            </div>
            <div v-if="group1.relatedInfoExists" 
              class="header-search-tab-item ga-qa-detail-kanrenjouhou"
              @click="state.visibleRelated = !state.visibleRelated;"
              :class="{'is-active':state.visibleRelated}"
              >
              <span class="text ga-qa-detail-kanrenjouhou" role="tab">関連情報</span>
            </div>
          </div>
          <div class="header-search-arrow">
            <FontawesomeIcon icon="angle-down" class="icn" />
          </div>
          <div class="header-search-link"
            v-if="group1.relatedContentsExist || group1.formDownloadsExist || group1.isAboutBookShown"
          >
            <span v-if="group1.relatedContentsExist"
              role="button" class="header-search-link-text ga-qa-detail-naiyougenzai"
              @click="group1.openCurrentContentsWindow()"
            >内容現在</span>
            <span v-if="group1.formDownloadsExist"
              role="button" class="header-search-link-text ga-qa-detail-shoshiki-download"
              @click="state.visibleDocumentDownloads = true"
            >書式ダウンロード</span>
            <span role="button" class="header-search-link-text ga-qa-detail-shoseki"
              v-if="group1.isAboutBookShown"
              @click="state.visibleAboutBook = true"
            >書籍情報</span>
          </div>
          <div class="header-search-select">
            <div class="formparts select">
              <div class="select-label"
                @click="state.visibleSelectRevision = true"
              >{{ group1.revisionName }}<FontawesomeIcon icon="angle-down" class="icn" /></div>
            </div>
          </div>
        </form>
        <div class="header-label ga-qa-bookmark" role="button"
          v-if="!isFromAdminSystem()"
          @click="group1.onBookmarkButtonClicked"
          :class="{'is-active':group1.isBookmarked}"
        >
          <FontawesomeIcon v-if="group1.isBookmarked" :icon="['fa','bookmark']" size="lg" class="ga-qa-bookmark" />
          <FontawesomeIcon v-else :icon="['far','bookmark']" size="lg" class="ga-qa-bookmark" />
        </div>
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !group1.isBookPreview && !visibleMenu"
        >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <div id="navi"
          ref="navigation"
          v-show="state.visibleNavi"
          :class="{'is-fullsize': group1.isFullSizeNavigation}"
          >
          <div class="navi-func-link" id="navi-func-link">
            <span role="button"
              @click="group1.openAllTableOfContents"
              class="text">すべて開く</span>
            <span role="button"
              @click="group1.closeAllTableOfContents"
              class="text">すべて閉じる</span>
          </div>
          <div class="navi-func-icon">
            <span role="button" class="icon"
              v-if="!group1.isFullSizeNavigation"
              @click="group1.isFullSizeNavigation = true"
              >
              <span class="tip">拡大</span>
              <FontawesomeIcon :icon="['far','expand-alt']" />
            </span>
            <span role="button" class="icon"
              v-if="group1.isFullSizeNavigation"
              @click="group1.isFullSizeNavigation = false"
              >
              <span class="tip">縮小</span>
              <FontawesomeIcon :icon="['far','compress-alt']" />
            </span>
            <span role="button" class="icon ga-qa-mokuji-print"
              @click="printTarget('navi-list')"
              v-show="group1.isTableOfContentsAreaPrintable"
            >
              <span class="tip">印刷</span>
              <FontawesomeIcon :icon="['far','print']" class="ga-qa-mokuji-print" />
            </span>
          </div>

          <div id="navi-content" class="navi-content-wrp">

            <!-- Web画面で表示する書籍名 -->
            <div class="navi-title" id="navi-title">{{ group1.bookTitle }}</div>

            <div class="list02" id="navi-list">

              <!-- 印刷で表示する書籍名 -->
              <div class="print-navi-title">{{ group1.bookTitle }}</div>

              <FontawesomeIcon v-if="!group1.isListBookTableOfContentsLoaded"
                :icon="['fal','spinner-third']" size="2x" class="icn fa-spin center" />
              <template v-else>
                <PCQADetailTableOfContentsTreeItem
                :model="group1.tableOfContentsAreaTreeData"
                @emitTitleClicked="group1.onQATitleOfTableOfContentsClicked"
                  />
              </template>

            </div>

          </div>
        </div>
        <main id="main"
          ref="main"
          :class="{'is-hidden': group1.isFullSizeNavigation}"
          >
          <div class="box02 white box-pdf-wrp">
            <div class="navi-pdf" v-if="group1.type === 2">
              <span class="navi-pdf-title">別ウィンドウで開く</span>
              <template v-if="group1.isBookPreview">
                <span class="navi-pdf-link">PDF</span>
                <span class="navi-pdf-link">ページ</span>
              </template>
              <template v-else>
                <a :href="'/lc/app'+(this.$route.path).replace('qa-detail', 'qa-detail-pdf')" target="_blank" class="navi-pdf-link ga-qa-detail-pdf">PDF</a>
                <a @click="group1.openDetailInNewWindow" class="navi-pdf-link ga-qa-detail-pdf" role="button">ページ</a>
              </template>
            </div>
            <div class="navi-func-icon">
              <!-- <a v-if="group1.type === 2" :href="group1.pdfURLStatic" target="_blank" class="icon">
                <span class="tip">別窓で開く</span>
                <span style="font-size:1.4rem;margin-right:5px;">PDF</span><FontawesomeIcon :icon="['far','external-link']" />
              </a>

              <a v-if="group1.type === 2" :href="group1.pdfURLDownload" download="download.pdf" class="icon">
                <span class="tip">PDFダウンロード</span>
                <FontawesomeIcon :icon="['far','file-pdf']" />
              </a> -->
              <span v-if="group1.type === 2 && !isFromAdminSystem()" role="button" class="icon"
                @click="state.visibleNoteSelect = true"
                >
                <span class="tip">ノートに保存</span>
                <IcnNote class="icn svg-inline--fa" />
              </span>
              <!-- <span v-if="group1.type === 2" role="button" class="icon"
                @click="printPDF(group1.pdfURLStatic)"
                v-show="group1.isMainAreaPrintable"
              >
                <span class="tip">印刷</span>
                <FontawesomeIcon :icon="['far','print']" />
              </span>
              <span v-if="group1.type === 3" role="button" class="icon"
                @click="printTarget('summary')"
                v-show="group1.isMainAreaPrintable"
              >
                <span class="tip">印刷</span>
                <FontawesomeIcon :icon="['far','print']" />
              </span> -->

            </div>
            <!-- 設問詳細タイプが「2:QA」の場合 -->
            <template v-if="group1.type === 2">
              <!-- <PDFViewerApp id="pdf_viewer"
                :url="group1.pdfURLStatic"
                ref="refPDFViewerApp" /> -->
              <FontawesomeIcon v-if="!group1.isMainContentsLoaded" 
                :icon="['fal','spinner-third']" size="2x" class="icn fa-spin center" style="margin-top:48%" />
              <template v-else>
                <iframe
                  :src="group1.pdfURLStatic"
                  :key="group1.pdfURLStatic"
                  style="width:100%;"
                  :style="{
                  'height': 'calc(100vh - ' + outerFramePaddingTop + 'px - ' + mainAreaPadingTop + 'px)',
                  'visibility':
                  (!state.visibleNoteSelect && 
                  !state.visibleAboutBook &&
                  !group1.visibleRelatedData &&
                  !state.visibleDocumentDownloads &&
                  !state.visibleSelectRevision &&
                  !group1.visibleOldAndNewMappings &&
                  !visibleMenu &&
                  !common.systemError.show &&
                  !common.notice.show)
                  ? 'visible' : 'hidden'
                  }"
                  frameborder="0">
                </iframe>
              </template>
            </template>
            <!-- 設問詳細タイプが「3:あらまし」の場合 -->
            <template v-if="group1.type === 3">
              <div id="summary" class="summary-container" style="overflow-y:auto;"
                :style="{ height: 'calc(100vh - ' + outerFramePaddingTop + 'px - ' + mainAreaPadingTop + 'px - ' + group1.frontendLoginInfoAreaHeight + 'px)' }"
              >
                <FontawesomeIcon v-if="!group1.isMainContentsLoaded" 
                  :icon="['fal','spinner-third']" size="2x" class="icn fa-spin center" />
                <template v-else>
                  <template v-for="(item, index) in group1.contents">
                    <h1 :key="'contens_' + index" v-if="item.classification === 4" class="hdg01" v-html="escapeHTMLAndBr(item.title)"></h1>
                    <h2 :key="'contens_' + index" v-if="item.classification === 5" class="hdg02" v-html="escapeHTMLAndBr(item.title)"></h2>
                    <h3 :key="'contens_' + index" v-if="item.classification === 6" class="hdg03" v-html="escapeHTMLAndBr(item.title)"></h3>
                    <div :key="'contens_' + index" v-if="item.classification === 7" class="list03">
                      <ul>
                        <li :key="'contents2_' + index2" v-for="(item2, index2) in item.contents">
                          <!-- タイトル1行目 -->
                          <a v-if="item2.qa_id" 
                            @click.prevent.stop="group1.onTitleOfSummaryClicked(item2.qa_id)" 
                            class="main" role="button" v-html="item2.title_first_line"></a>
                          <span v-else class="main">{{ item2.title_first_line }}</span>
                          <!-- タイトル2行目以降 -->
                          <template v-for="(line, index2) in item2.title_after_second_lines">
                            <span :key="'second_line_' + index2" class="indent" v-html="line"></span>
                          </template>
                        </li>
                      </ul>
                    </div>
                    <p :key="'contens_' + index" v-if="item.classification === 9" class="txt" v-html="escapeHTMLAndBr(item.title)"></p>
                  </template>
                </template>
              </div>
            </template>
          </div>
        </main>
        <div id="related"
          ref="related"
          v-show="state.visibleRelated"
          :class="{'is-hidden': group1.isFullSizeNavigation}"
          >
          <div class="navi-func-icon"
            v-show="group1.isBookExampleRelatedAreaPrintable"
          >
            <span role="button" class="icon ga-qa-kanrenjouhou-print"
              @click="printTarget('related-content')"
              >
              <span class="tip">印刷</span>
              <FontawesomeIcon :icon="['far','print']" class="ga-qa-kanrenjouhou-print" />
            </span>
          </div>
          <div style="overflow-y:auto;"
            :style="{ height: 'calc(100vh - 126px - ' + group1.frontendLoginInfoAreaHeight + 'px)'}"
          >

            <div id="related-content">

              <FontawesomeIcon v-if="!group1.isListBookExampleRelatedInfoLoaded" 
              :icon="['fal','spinner-third']" size="2x" class="icn fa-spin center" />
              <template v-else>

                <p v-if="!group1.relatedDataExists" class="pl24 mt24">表示する内容がありません。</p>
                <ul v-else class="list-border pl24 pr24">

                  <li v-if="group1.related_laws.length > 0" class="list-border-item">
                    <div class="hdg04 mb16">関連法令</div>
                    <template v-for="(item, index) in group1.related_laws">

                      <div v-if="item.key === ''" :key="'laws_title1_' + index" class="txt mb8">{{ item.title }}</div>
                      <div v-else :key="'laws_title2_' + index" @click="group1.openRelatedInfo(item.relatedInfoTarget, item.key, item.title)" 
                        class="txt-blue mb8 ga-qa-detail-kanrenhourei" role="button">{{ item.title }}</div>

                      <template v-if="item.articles.length > 0">
                        <ul :key="'laws_articles_' + index" class="list-inline">
                          <li v-for="(item2, index2) in item.articles" :key="'laws_article_' + index2" class="list-inline-item">

                            <span v-if="item2.key === ''" class="txt">{{ item2.title }}</span>
                            <span v-else @click="group1.openRelatedInfo(item2.relatedInfoTarget, item2.key, item.title + '　' + item2.title)"
                              class="txt-blue ga-qa-detail-kanrenhourei" role="button">{{ item2.title }}</span>

                          </li>
                        </ul>
                      </template>
                    </template>
                  </li>

                  <li v-if="group1.related_notifications.length > 0" class="list-border-item">
                    <div class="hdg04 mb16">関連通達</div>
                    <template v-for="(item, index) in group1.related_notifications">

                      <div v-if="item.key === ''" :key="'notifications_title1_' + index" class="txt mb8">{{ item.title }}</div>
                      <div v-else :key="'notifications_title2_' + index" 
                        @click="group1.openRelatedInfo(item.relatedInfoTarget, item.key, item.title)" 
                        class="txt-blue mb8 ga-qa-detail-kanrentsuutatu" role="button">{{ item.title }}</div>

                      <template v-if="item.articles.length > 0">
                        <ul :key="'notifications_articles_' + index" class="list-inline">
                          <li v-for="(item2, index2) in item.articles" :key="'notifications_article_' + index2" class="list-inline-item">

                            <span v-if="item2.key === ''" class="txt">{{ item2.article }}</span>
                            <span v-else @click="group1.openRelatedInfo(item2.relatedInfoTarget, item2.key, item.title + '　' + item2.article)"
                              class="txt-blue ga-qa-detail-kanrentsuutatu" role="button">{{ item2.article }}</span>

                          </li>
                        </ul>
                      </template>
                    </template>
                  </li>

                  <li v-if="group1.related_precedents.length > 0" class="list-border-item">
                    <div class="hdg04 mb16">関連判例</div>
                    <template v-for="(item, index) in group1.related_precedents">

                      <div v-if="item.key === ''" :key="'precedents_title1_' + index" class="txt mb20">{{ item.title }}</div>
                      <div v-else :key="'precedents_title2_' + index"
                        @click="group1.openRelatedInfo(item.relatedInfoTarget, item.key, item.title)"
                        class="txt-blue mb20 ga-qa-detail-kanrenhanrei" role="button">{{ item.title }}</div>

                    </template>
                  </li>

                  <li v-if="group1.related_decisions.length > 0" class="list-border-item">
                    <div class="hdg04 mb16">関連裁決（国税不服審判所）</div>
                    <template v-for="(item, index) in group1.related_decisions">

                      <div v-if="item.key === ''" :key="'decisions_title1_' + index" class="txt mb20">{{ item.title }}</div>
                      <div v-else :key="'decisions_title2_' + index" 
                        @click="group1.openRelatedInfo(item.relatedInfoTarget, item.key, item.title)"
                        class="txt-blue mb20 ga-qa-detail-kanrensaiketsu" role="button">{{ item.title }}</div>

                    </template>
                  </li>

                </ul>

              </template>
              <iframe style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%; z-index: -1;" src="about:blank"></iframe>

            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->

      <!-- QA詳細は「TOP」は非表示 （iframe内のPDFのスクロールは制御できない）
        <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span> -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted, watch } from '@vue/composition-api'

import PCPrint from '@/components/pc/partial/PCPrint.vue'

import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCBasicToast from '@/components/pc/popup/PCBasicToast.vue'
import PCNoteSelect from '@/components/pc/popup/PCNoteSelect.vue'
import PCQAAboutBook from '@/components/pc/popup/PCQAAboutBook.vue'
import PCQADocumentDownloads from '@/components/pc/popup/PCQADocumentDownloads.vue'
// import PCQAOldAndNewMappings from '@/components/pc/popup/PCQAOldAndNewMappings.vue'
import PCQARelatedData from '@/components/pc/popup/PCQARelatedData.vue'
import PCQASelectRevision from '@/components/pc/popup/PCQASelectRevision.vue'
// import PDFViewerApp from '@/components/vendor/pdf/PDFViewerApp.vue'

import * as logicQADetail from '@/logic/qa/QADetail'
import { isFromAdminSystem, escapeHTMLAndBr } from '@/util/common'

import PCQADetailTableOfContentsTreeItem from '@/components/pc/partial/qa/PCQADetailTableOfContentsTreeItem'

export default defineComponent({
  components: {
    PCPrint,
    PCMenu,
    PCBasicToast,
    PCNoteSelect,
    PCQAAboutBook,
    PCQADocumentDownloads,
    PCQARelatedData,
    PCQASelectRevision,
    // PDFViewerApp,
    // PCQAOldAndNewMappings,
    PCQADetailTableOfContentsTreeItem
  },  
  props: {
    // QA ID：URLで渡された値(/routes/index.jsで定義)
    qaId: {
      type: Number,
      required: true,
      default: 0
    },
    // 書籍ID：URLで渡された値(/routes/index.jsで定義)
    bookId: {
      type: Number,
      required: false,
      default: 0
    },
    // 書籍リビジョンID：URLで渡された値(/routes/index.jsで定義)
    bookRevisionId: {
      type: Number,
      required: false,
      default: 0
    }
  },
  setup (props, context) {
    const store = context.root.$store
    const { common } = store.state
    const router = context.root.$router

    // 外枠(青い部分)のpadding top
    const outerFramePaddingTop = 86
    // メインエリア(PDF or あらまし表示エリア)のpadding top
    const mainAreaPadingTop = 43

    /**
     * 本文PDFのRef
     * ref="refPDFViewerApp"を設定しているノード(コンポーネント)の参照
     */
    const refPDFViewerApp = ref()

    /**
     * 目次のスクロール高さを更新する
     */
    const updateNaviListHeight = () => {
      const naviFunkLink = document.getElementById('navi-func-link')
      const naviTitle = document.getElementById('navi-title')
      const naviList = document.getElementById('navi-list')
      const styleStr = 'calc(100vh - ' + outerFramePaddingTop + 'px - ' + naviFunkLink.clientHeight + 'px - ' + naviTitle.clientHeight + 'px - ' + group1.frontendLoginInfoAreaHeight + 'px)'
      naviList.style.height = styleStr 
    }

    onMounted(() => {
      // 目次のスクロール高さを更新する
      updateNaviListHeight()
      window.addEventListener('resize', (event) => {
        updateNaviListHeight()
      })

      // 初期表示
      group1.init()
    })

    const group1 = logicQADetail.getGroup(props, context)

    const state = reactive({
      visibleNoteSelect: false, // ノートポップアップ表示用のフラグ
      visibleAboutBook: false, // 書籍情報ポップアップ表示用のフラグ
      visibleDocumentDownloads: false, // 書式ダウンロードポップアップ表示用のフラグ
      visibleNavi: true, // 目次表示用フラグ
      visibleRelated: false, // 関連情報表示用フラグ
      visibleSelectRevision: false // 年度指定ポップアップ表示用フラグ
    })

    const fitAutoPDFViewer = () => {
      context.refs.refPDFViewerApp.fitAutoViewer()
    }

    return {
      outerFramePaddingTop,
      mainAreaPadingTop,
      group1,
      state,
      refPDFViewerApp,
      fitAutoPDFViewer,
      isFromAdminSystem,
      escapeHTMLAndBr,
      common
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('qa/setReferrerObject', from)
    })
  }
})
</script>

<style lang="scss" scoped>
#wrapper:after {
  top: -10px;
}
#header {
  [role="tab"] {
    cursor: pointer;
  }
  @media screen and (min-width: 1160px) {
    .header-search-arrow {
      display: none;
    }
  }
  @media screen and (max-width: 1159px) {
    .header-search {
      position: relative;
      &-link {
        position: absolute;
        z-index: $index-header-tip;
        bottom: -30px;
        left: 80px;
        margin: 0;
        background-color: #fff;
        font-size: 1.4rem;
        padding: 12px;
        border-radius: 4px;
        box-shadow: 0 3px 6px rgba(0,0,0,.16);
        color: $color-link;
      }
    }
  }
  .header-search-tab {
    &-item:last-child {
      .text {
        border-right: 1px solid rgba(255,255,255,.1);
      }
    }
  }
}
#content {
  display: flex;
  flex-wrap: nowrap;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
}
.navi-func-link {
  box-sizing: border-box;
  border-width: 0px;
  font-size: 1.2rem;
  color: $color-sup;
  // margin: 30px 92px 20px 24px;
  padding: 30px 92px 20px 24px;
  .text {
    text-decoration: underline;
  }
  .text + .text {
    padding-left: 20px;
    margin-left: 20px;
    border-left: 1px solid $color-line;
  }
}
.navi-func-icon {
  position: absolute;
  right: 20px;
  top: 30px;
  z-index: 1;
  .icon {
    color: $color-link;
    white-space: nowrap;
    margin-right: 10px;
    background-color: #fff;
    display: inline;
    padding: 5px;
    border-radius: 4px;
    border: 0;
    position: relative;
    .tip {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translate3d(-50%,0,0);
      font-size: 1.4rem;
      font-weight: normal;
      white-space: nowrap;
      opacity: 0;
      transition: opacity .2s;
    }
    &:hover {
      box-shadow: 0 5px 20px rgba(0,0,0,.16);
      .tip {
        opacity: 1;
      }
    }
  }
}
.navi-title {
  // padding: 0 24px;
  // margin-top: 10px;
  // margin-bottom: 8px;
  box-sizing: border-box;
  border-width: 0px;
  padding: 10px 24px 8px 24px; 
  color: $color-hdg;
  font-size: 1.8rem;

  display: block;
}
.print-navi-title {
  display: none;
}
// 印刷の場合はスクロール内のタイトルを使用する
@media print {
  .navi-title {
    display: none;
  }
  .print-navi-title {
    display: block;
    font-size: 130%;
    margin-top: 1rem; 
    margin-bottom: 1rem; 
  }
}
#navi {
  position: relative;
  padding: 0;
  background-color: transparent;
  border-radius: 8px 0 0 8px;
  width: 25%;
  margin-top: 0;
  left: 0;
  border-right: 1px solid $color-line;
  transition: width .2s ease;
  &.is-fullsize {
    width: 100%;
    border-right: 0;
  }
}
::v-deep #navi-content {
  // overflow: auto;
  // line-height: 1.2em;
  .list02 {
    margin-top: 0;
    overflow: auto;
    &-list {
      padding-bottom: 40px;
    }
    &-item {
      .wrap { 
        padding-right: 24px;
        padding-left: 24px;
      }
      .button {
        right: 0;
        width: 48px;
        font-size: 1.4rem;
      }
      &.is-selected {
        background-color: $color-selected;
      }
      &:not(.is-parent) .wrap .label:before {
        top: 6px;
      }
    }
    .wrap .label .icn-before {
      top: 2px;
    }
  }
}
#navi-list {
  overflow: auto;
  line-height: 1.2em;
}
#main,
#related {
  transition: all .2s ease;
  &.is-hidden {
    width: 0;
    flex: 0;
    visibility: hidden;
    opacity: 0;
  }
}
#main {
  margin: 0;
  flex: 1 1 50%;
  .box02 {
    border-radius: 8px 8px 0 0;
    padding-top: 43px;
  }
  .box-pdf-wrp{
    .navi-pdf{
      position: absolute;
      top: 11px;
      left: 20px;
      //transform: translate(-50%, -50%);
      .navi-pdf-title {
        margin-right: 16px;
      }
      .navi-pdf-link{
        color: #005BAC;
        & + .navi-pdf-link {
          margin-left: 8px;
          padding-left: 8px;
          border-left: 1px solid #DDDDDD;
        }
      }
    }
    .navi-func-icon{
      top: 12px;
      .icon .tip{
        top: -10px;
      }
    }
  }
}
#related {
  position: relative;
  width: 25%;
  border-radius: 0 8px 8px 0;
  padding: 40px 0;
  border-left: 1px solid $color-line;
  #related-content {
    line-height: 1.2em;
  }
  [class*="hdg0"] {
    font-weight: normal;
  }
  .txt-blue[role="button"] {
    @include hoverOpacity;
  }
  .txt-sup {
    line-height: 1.2em;
  }
  .list-border-item {
    > .txt:last-child {
      margin-bottom: 0;
    }
  }
  .list-inline {
    margin-left: 20px;
    margin-bottom: 16px;
    margin-top: 6px;
    &:last-child {
      margin-bottom: 0;
    }
    &-item {
      .txt-sup {
        color: $color-content;
        font-size: inherit;
      }
    }
    > li {
      margin-right: 12px;
      margin-top: 6px;
    }
  }
}
// あらまし用
.summary-container {
  padding: 40px;
  .txt,
  .list03,
  .hdg01,
  .hdg02,
  .hdg03,
  .hdg04 {
    line-height: 1.2em;
    margin-top: 1.6em;
    margin-bottom: 0;
    &:first-child {
      margin-top: 0;
    }
  }
  .list03{
    li{
      padding: 8px 0;
    }
  }
  .hdg02{
    font-size: 2.4rem;
  }
  .list03-label {
    line-height: 1.2em;
    &:hover{
      opacity: 0.7;
    }
  }
  .txt {
    line-height: 2;
  }
  a.main {
    color: $color-link;
  }
  .indent {
    display: block;
    color: $color-content;
    padding: 0.6em 0 0 10px;
  }
}
// フロントエンドログイン時
.login-bar {
  position: fixed;
  top: 0;
  height: 50px;
  box-sizing: border-box;
  z-index: 10;
  width: 100%;
  background-color: $color-hdg;
  color: #fff;
  font-size: 1.8rem;
  padding: 12px 52px 12px 12px;
}
.is-visible-login {
  #bg-image ,
  .menu-bar ,
  #header ,
  .popup-wrapper {
    top: 50px;
  }
  #wrapper {
    padding-top: 136px;
  }
  #bg-image {
  top: 50px;
  }
  .is-hidden-header {
    #wrapper {
      padding-top: 66px;
    }
  }
}

</style>
